module.exports = __webpack_public_path__ + "static/media/Evira final Cam 03.0acfa7bb.webp";